import React from "react";

const ChecklistInputField = ({
  label,
  required = false,
  fieldInfo = null,
  type,
  name,
  validation = null,
  ...props
}) => (
  <div className={`checklist-input-field-${name}`}>
    {label && (
      <div>
        <label htmlFor={name}>
          {label}
          {required && "*"}
        </label>
        {fieldInfo && (
          <span className="flex items-center text-sm">
            <i>{fieldInfo}</i>
          </span>
        )}
      </div>
    )}
    {type !== "textarea" && <input type={type} name={name} required={required} id={name} {...props} />}
    {type === "textarea" && <textarea name={name} required={required} rows={6} id={name} {...props} />}
    {validation && <span>{validation}</span>}
  </div>
);

export default ChecklistInputField;
